import request from '../../../common/request/index.js'
const api = request.api

export default {
  get: async (id) => {
    return api.get(`station/station/${id}`)
  },
  search: async (data) => {
    return api.post(`station/station/search`, data)
  },
  page: async (data) => {
    return api.post(`station/station/page`, data)
  },
  put: async (data) => {
    return api.put(`station/station`, data)
  },
  post: async (data) => {
    return api.post(`station/station`, data)
  },
  del: async (id) => {
    return api.delete(`station/station/${id}`)
  },
  adjustReserve: (data) => {
      // 后端 reserve.js 中的路由是 router.post('/manual', ...)
      // 对应的完整路径通常是 /reserve/reserve/manual
      return api.post('reserve/reserve/manual', data);
    },
  getOptions: async (enterpriseId) => {
      return api.get(`station/station/options`, { enterpriseId })
    },
  generateQrCode: async (id) => {
    return api.post(`station/station/generateQrCode`, { id })
  },
  // ========== 新增：生成小程序码 ==========
  generateWxCode: async (params) => {
    return api.post(`station/station/generateWxCode`, params)
  },
  // 生成聚合码（普通二维码，内容为 H5 支付页）
  generateUnionCode: (params) => {
    return api.post(`station/station/generateUnionCode`, params);
  },
  // 生成支付宝支付码
  generateAlipayCode: (params) => {
    return api.post(`station/station/generateAlipayCode`, params);
  },
  // 导出订单数据
  export: (params) => {
    return api.post('station/station/export', params, { responseType: 'blob' })
  },
  // ========== 新增：站点订单明细统计 ==========
  orderStatistics: (params) => {
    return api.get(`station/station/orderStatistics`, params)
  },
  uploadSplitPic: (params) =>   { return api.post(`station/station/split/uploadPic`, params)},
  openSplit: (params) =>   { return api.post(`station/station/split/open`, params)},
  querySplit: (orderNo) =>  { return api.get(`station/station/split/query/querySplit?orderNo=${orderNo}`)}
}